import { isNotNilOrEmpty } from '../../value/isNotNilOrEmpty';
import { isNumber } from '../isNumber';
import { isString } from '../isString';
/**
 * Attempts to parse a string as an int
 *
 * @category Type
 * @since v2.41.0
 * @param  {string} value The string value to parse
 * @param  {T} defaultValue The default value to return if the string cannot be parsed
 * @returns {number | T} The parsed int or the default value
 * @example
 * tryParseInt('25')                //=> 0
 * tryParseInt('Not Parsable', 1)   //=> 1
 * @docgen_example
 * tryParseInt('25');
 */
export var tryParseInt = function (value, defaultValue) {
    if (value === Infinity ||
        value === -Infinity) {
        return value;
    }
    if (isNotNilOrEmpty(value) &&
        ((isString(value) && value.length > 0) || isNumber(value)) &&
        !isNaN(value)) {
        return parseInt(value);
    }
    return defaultValue;
};
